module.exports = __webpack_public_path__ + "img/big2-7.b3c34854.jpg";